import React from 'react'
import {connect} from "react-redux"
import Vimeo from '@u-wave/react-vimeo';

import VideoThumb from '../video/VideoThumb'
import Video from '../video/Video'
import SessionComments from '../ui/SessionComments';
import DoneImg from '../ui/images/check_circle_white.svg'
import ShowCategories from '../ui/ShowCategories'
import CategoryAreas from '../ui/CategoryAreas'

import Avatar from '../user/Avatar'
import moment from 'moment'

import { setModal, fetchPracticeById } from '../../actions/index'
import { toggleVideoDoneAndSave } from '../../actions/patient'
import { getGalleryItemsForPatient } from '../../actions/gallery'

@connect((store) => {
	return {
    therapy_areas: store.therapy_areas,
		therapy_categories: store.therapy_categories,
    sessions: store.sessions,
    videos: store.videos,
    modal: store.modal,
    patients: store.patients,
    gallery: store.gallery,
   }
})
class ParentSession extends React.Component {
	constructor(props) {
    super(props);
    this.state = {
      "active_category": null
    }
    this.toggleVideoDone = this.toggleVideoDone.bind(this)
    this.setActiveVideo = this.setActiveVideo.bind(this)
    this.categoryAreas = this.categoryAreas.bind(this)
    this.categoryClick = this.categoryClick.bind(this)
    this.loadGallery = this.loadGallery.bind(this)
    this.loadGalleryNoteTemplate = this.loadGalleryNoteTemplate.bind(this)
    this.photoNoteTemplate = this.photoNoteTemplate.bind(this)
    this.documentNoteTemplate = this.documentNoteTemplate.bind(this)
    this.videoNoteTemplate = this.videoNoteTemplate.bind(this)
  }

  componentDidMount() {
    // console.log(this.props);
    this.props.dispatch(getGalleryItemsForPatient(this.props.session.patient))
    this.props.dispatch(fetchPracticeById(this.props.session.practice))
  }

  categoryClick(id){
    let _id = this.state.active_category === id? null : id
    this.setState({
      "active_category": _id
    })
  }


  setActiveVideo(id){
		let data = {...this.props.modal.data, activeVideoId: id}
		this.props.dispatch(setModal('ParentSession', null, {...this.props.modal.data, ...data }, true, 'fullscreen'))
	}

  toggleVideoDone(sessionId, videoId){
		let { dispatch } = this.props;
		dispatch(toggleVideoDoneAndSave(sessionId, videoId))
	}

  categoryAreas(){
    let {therapy_areas, sessionId, sessions} = this.props;
    let session = sessions[sessionId];

    if(!therapy_areas) return []

    return session.therapy_areas
    .filter(areaId => {
				if (therapy_areas[areaId])
				 return therapy_areas[areaId].categories.indexOf(this.state.active_category) !== -1
				else return false
			}
		 )
    .map(areaId => therapy_areas[areaId])
  }

  loadGallery(galleryIds, type) {
    const { gallery } = this.props;

    let documents = [];
    let photos = [];
    let videos = [];
    let formatedGallery = [];

    if (galleryIds.length > 0 && gallery.items !== undefined && gallery.items.length > 0) {
      galleryIds.forEach(galId => {
        let galIndex = gallery.items.findIndex((gal) => gal.id == galId);
        
        if (galIndex > -1 && type == gallery.items[galIndex].scope) {
          switch (gallery.items[galIndex].media) {
            case 'photo':
              photos.push(galId);
              break;
      
            case 'document':
              documents.push(galId);
              break;
      
            case 'video':
              videos.push(galId);
              break;
          
            default:
              break;
          }
        }
      });
      // console.log(documents);
      // console.log(photos);
      // console.log(videos);
      formatedGallery = documents.concat(photos);
      formatedGallery = formatedGallery.concat(videos);

      return formatedGallery.map(gal => (this.loadGalleryNoteTemplate(gal, type)));
    }
    return '';
  }

  loadGalleryNoteTemplate(galId, type) {
    const { gallery } = this.props;
    // console.log(galId);
    if (gallery.items.length) {
      let galIndex = gallery.items.findIndex((gal) => gal.id == galId);
      // console.log(gallery.items[galIndex]);
      if (galIndex > -1 && type == gallery.items[galIndex].scope) {
        switch (gallery.items[galIndex].media) {
          case 'photo':
            return this.photoNoteTemplate(gallery.items[galIndex]);
            break;
    
          case 'document':
            return this.documentNoteTemplate(gallery.items[galIndex]);
            break;
    
          case 'video':
            if (gallery.items[galIndex].url !== undefined &&
              gallery.items[galIndex].url !== 'Uploading Video' &&
              gallery.items[galIndex].url !== 'Failed to upload Video'
            ) {
              return this.videoNoteTemplate(gallery.items[galIndex]);
            }
            break;
        
          default:
            break;
        }
      }
    }
    return '';
  }

  photoNoteTemplate(gal) {
		return <div className="thumb photo" key={gal.id}>
			<img src={gal.url}/>
		</div>
	}

	documentNoteTemplate(gal) {
		return <div className="thumb file" key={gal.id}>
			<a href={gal.url} target="_blank" className="fileName">
			<svg fill="#c11515"  aria-hidden="true" focusable="false" data-prefix="far" data-icon="file-pdf" className="svg-inline--fa fa-file-pdf fa-w-12" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="#c11515" d="M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm250.2-143.7c-12.2-12-47-8.7-64.4-6.5-17.2-10.5-28.7-25-36.8-46.3 3.9-16.1 10.1-40.6 5.4-56-4.2-26.2-37.8-23.6-42.6-5.9-4.4 16.1-.4 38.5 7 67.1-10 23.9-24.9 56-35.4 74.4-20 10.3-47 26.2-51 46.2-3.3 15.8 26 55.2 76.1-31.2 22.4-7.4 46.8-16.5 68.4-20.1 18.9 10.2 41 17 55.8 17 25.5 0 28-28.2 17.5-38.7zm-198.1 77.8c5.1-13.7 24.5-29.5 30.4-35-19 30.3-30.4 35.7-30.4 35zm81.6-190.6c7.4 0 6.7 32.1 1.8 40.8-4.4-13.9-4.3-40.8-1.8-40.8zm-24.4 136.6c9.7-16.9 18-37 24.7-54.7 8.3 15.1 18.9 27.2 30.1 35.5-20.8 4.3-38.9 13.1-54.8 19.2zm131.6-5s-5 6-37.3-7.8c35.1-2.6 40.9 5.4 37.3 7.8z"></path></svg>
				<span>
					{gal.filename ? gal.filename : "File"}
					<small>PDF Document</small>
				</span>
			</a>
		</div>
	}

	videoNoteTemplate(gal) {
		return <div className="thumb video" key={gal.id}>
			<Vimeo
				responsive={true}
				video={gal.url.replace("/videos/", "")}
			/>
		</div>
  }

  render(){
    let { sessionId, sessions, close, videos, activeVideoId, therapy_categories, therapy_areas } = this.props;
    let { active_category, scroll_position }  = this.state;
    let session = sessions[sessionId];
    session.comments = session.comments || {};

    return <div className={"modal-fill " + (!activeVideoId && 'scroll')}>
      <div className="modal-header">
        <Avatar pic={session.therapist.picture} />
        <div className="modal-title fill">
          <b>
            {
              session.dateSent? <span>{moment(session.dateSent).format('ddd Do of MMM YYYY h:mm a')} - { moment(session.dateSent).fromNow()}</span>
              :
              <span>{moment(session.created).format('ddd Do of MMM YYYY h:mm a')} - { moment(session.created).fromNow()}</span>
            }
					</b>
        </div>
        <div className="close link" onClick={close}>X</div>
      </div>
      <div className="modal-content">
        <div>
            <p>
                <b>Session Date</b><br/>
                {moment(session.created).format('ddd Do of MMM YYYY h:mm a')}
            </p>
        </div>
				<div className="section paddingless">
          <div className="md-subhead"><center>Homework</center></div>
          <div className="video-grid grid horizontal-row">
            {session.videos.map(videoId => <div className="thumb"  key={videoId}>
              <div className="card dark marginless" style={
                  {
                    opacity: session.videos_done[videoId]? '1' : '0.6'
                  }
                }
								onClick={() => {
                  this.setActiveVideo(videoId)}}>
									<VideoThumb class="min-video" video={videos[videoId]}/>
                  { session.videos_done[videoId] && <img alt="Mark as done" src={DoneImg} style={{
    									height: '18px',
    									position: 'absolute',
    									right:'4px',
    									bottom:'4px'
    								}} />}
              </div>
            </div>)}
          </div>
	        <div>
	          <br />
	        	{session.parent_notes? session.parent_notes.split('\n').map((t, i)=><p key={`parent_notes_p_${i}`}>{t}</p>) : ''}
	        </div>
        </div>

          <div className="buttonify">
            <p>
              <b>Today's focus: </b>
            </p>
            <ShowCategories
              active_category={active_category}
              click={this.categoryClick}
              therapy_areas={session.therapy_areas.map(areaId => therapy_areas[areaId])}
              therapy_categories={therapy_categories}
              />
						<CategoryAreas active_category={active_category} therapy_areas={this.categoryAreas()} />

          </div>
          <div className="grid gallery ">
            { session.gallery && (
                this.loadGallery(session.gallery, 'public')
              )
            }
          </div>
					<div className="grid gallery ">
            { session.images && (
                session.images.map(img => <div className="image-container" key={img.orig}>
								<img className="shadow" role="presentation" src={img.orig} /></div>)
              )
            }
          </div>
          <div >
            <hr />
            <p><b>Comments</b></p>
            <SessionComments
							updateScroll={scroll_position}
              session={session}
              parent={true}
              therapist={false}
               />
          </div>
      </div>



      { activeVideoId && <div className="fullscreen video-player">
        <div className=" row">
          <p className="fill padding md-body1">{videos[activeVideoId].name}</p>
						<a className="link close padding" onClick={(e) => {
								this.setActiveVideo(null)
						}}>X</a>
        </div>
        <div className="extra-padding fill scroll-y">
          <div  className="video-area  card high">
            <div className="padding ">
              <div style={{'margin': '-8px'}}>
                <Video  video={videos[activeVideoId]}></Video >
              </div>
              <div className="padding">
                <p>{videos[activeVideoId].description}</p>
              </div>
            </div>
            <div className="card-footer primary-shade1">
            </div>
          </div>
        </div>
				<div className="action-area " >
						<div className="padding link  toggle-done" >
								{session.videos_done[activeVideoId] ? <a className="md-primary md-title vibrant link"
									>&#10004;</a> : <a className="md-grey md-title vibrant link"
								onClick={(e) => {
										this.toggleVideoDone(session._id, activeVideoId)
								}}>&#10004;</a>
							}
							<caption onClick={(e) => {
									this.toggleVideoDone(session._id, activeVideoId)
							}} style={{
									opacity: '0.7'
								}}>{session.videos_done[activeVideoId]? "Done" : "Not done"}</caption>
						</div>

				</div>
      </div>}
    </div>
  }

}

ParentSession.defaultProps = {
  sessions:{},
  therapy_areas:{},
  session: {},
  videos:{},
  activeVideoId: null,
  setActiveVideo: ()=>{}
}


export default ParentSession;



// WEBPACK FOOTER //
// ./src/components/parent/ParentSession.jsx